import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, tap, of, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from '../services/localstorage.service';
import { SnackBarService } from '../services/snack-bar-service.service';
import { IConsultaSubFrotaModel } from '../subFrota/model/subFrota.model';
import { IFiltroFrotaContatoModel, IListaFrotaContatoModel, IConsultaFrotaModel, IFiltroFrotaModel, IBuscaFrotaModel } from './model/frota.model';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class FrotaService {
  
  public usuario!: LoginModel;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient, 
      private localStorageService: LocalStorageService,
      private snackBar: SnackBarService) { 
    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  listFrotaContatos(filtro: IFiltroFrotaContatoModel) : Observable<IListaFrotaContatoModel>{
    
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaContatoFrota;

    return this.http.post<IListaFrotaContatoModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os contatos da Frota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IListaFrotaContatoModel>('Não foi possível consultar os contatos da Frota.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  listFrota(filtro: IFiltroFrotaModel): Observable<IConsultaFrotaModel>{

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaFrota;

    return this.http.post<IConsultaFrotaModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as Frotas.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaFrotaModel>('Não foi possível consultar as Frotas.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  searchFrota(filtro: IBuscaFrotaModel): Observable<IConsultaFrotaModel>{

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_BuscaFrota;

    return this.http.post<IConsultaFrotaModel>(url, filtro, this.httpOptions).pipe(map(response => {
      response.retorno.forEach( (frota) => {
        frota.busca = frota.codigo.toString().padStart(6,'0') + ' - ' + frota.nomeReduzido.trim() + ' - ' + frota.descricao.trim() + ' - ' + frota.municipio.trim() + ' - ' + frota.estado;
      });
      return response;
    }));
  }

  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }
}
